<template>
  <portlet :icon="'fal fa-envelope'" :title="'E-mail configuratie'" :actionsBlock="false">
    <template slot="portletBody">
      <div v-if="loading" class="text-center py-5">
        <i class="fal fa-spinner fa-spin fa-2x text-primary"></i>
      </div>
      <template v-else>
        <div v-for="(reportData, reportKey) in config" :key="reportKey" class="mb-5">
          <p class="text-primary font-weight-bold mb-3">{{ reportLabels[reportKey] || reportKey }}</p>
          <div class="row">
            <div v-for="(deptData, deptName) in reportData" :key="deptName" class="col-md-4 mb-3">
              <div class="card h-100">
                <div class="card-header py-2">
                  {{ deptName }}
                </div>
                <div class="card-body">
                  <div
                    v-for="(email, idx) in deptData.receivers"
                    :key="idx"
                    class="d-flex align-items-center mb-2"
                  >
                    <span class="text-truncate flex-grow-1">{{ email }}</span>
                    <button
                      class="btn btn-sm btn-outline-danger ml-2 flex-shrink-0"
                      @click="removeEmail(reportKey, deptName, idx)"
                    >
                      <i class="fal fa-times"></i>
                    </button>
                  </div>
                  <p v-if="!deptData.receivers.length" class="text-muted mb-2">Geen ontvangers</p>
                  <div class="input-group mt-3">
                    <input
                      type="email"
                      class="form-control"
                      placeholder="E-mailadres toevoegen..."
                      :value="newEmails[reportKey + '_' + deptName]"
                      @input="newEmails[reportKey + '_' + deptName] = $event.target.value"
                      @keyup.enter="addEmail(reportKey, deptName)"
                    />
                    <div class="input-group-append">
                      <button class="btn btn-primary" @click="addEmail(reportKey, deptName)">
                        <i class="fal fa-plus"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr />
        </div>
        <button class="btn btn-primary" @click="save">
          <i class="fal fa-save mr-2"></i> Opslaan
        </button>
      </template>
    </template>
  </portlet>
</template>

<script>
export default {
  data: function() {
    return {
      loading: true,
      config: {},
      newEmails: {},
      reportLabels: {
        dailyReport: 'Dagelijks rapport',
        fase34Report: 'Fase 3/4 rapport',
        publishedVacancies: 'Gepubliceerde vacatures',
        reportGemeente: 'Rapport gemeente',
        reportSocials: 'Rapport socials',
        reportUWV: 'Rapport UWV',
        sickLeaveAroundPlacementEnd: 'Ziekmelding bij plaatsingseinde',
      },
    };
  },
  async created() {
    var snapshot = await this.$FB.collection('mailConfig').get();
    var rawDocs = {};

    // Collect all docs and build union of all departments across all docs
    var allDepartments = {};
    snapshot.forEach(function(doc) {
      var data = JSON.parse(JSON.stringify(doc.data()));
      rawDocs[doc.id] = data;
      Object.keys(data).forEach(function(dept) {
        allDepartments[dept] = true;
      });
    });

    // Also include the current user's departments
    this.$store.state.users.me.departments.forEach(function(d) {
      allDepartments[d.name] = true;
    });

    var deptList = Object.keys(allDepartments).sort();

    // Ensure every doc has every department
    var config = {};
    Object.keys(rawDocs).forEach(function(reportKey) {
      var data = rawDocs[reportKey];
      deptList.forEach(function(dept) {
        if (!data[dept]) {
          data[dept] = { receivers: [] };
        }
      });
      config[reportKey] = data;
    });

    this.config = config;
    this.loading = false;
  },
  methods: {
    addEmail: function(reportKey, deptName) {
      var key = reportKey + '_' + deptName;
      var email = (this.newEmails[key] || '').trim();
      if (!email) return;
      if (this.config[reportKey][deptName].receivers.indexOf(email) === -1) {
        this.config[reportKey][deptName].receivers.push(email);
        this.saveReport(reportKey);
      }
      this.$set(this.newEmails, key, '');
    },
    removeEmail: function(reportKey, deptName, idx) {
      this.config[reportKey][deptName].receivers.splice(idx, 1);
      this.saveReport(reportKey);
    },
    saveReport: function(reportKey) {
      this.$FB.collection('mailConfig').doc(reportKey).set(this.config[reportKey])
        .then(function() {
          this.$toasted.global.successRequest({ message: 'Opgeslagen' });
        }.bind(this))
        .catch(function() {
          this.$toasted.global.failedRequest({ message: 'Opslaan mislukt' });
        }.bind(this));
    },
    save: async function() {
      this.$store.commit('setLoading', true);
      try {
        var saves = Object.keys(this.config).map(function(reportKey) {
          return this.$FB.collection('mailConfig').doc(reportKey).set(this.config[reportKey]);
        }.bind(this));
        await Promise.all(saves);
        this.$toasted.global.successRequest({ message: 'E-mail configuratie opgeslagen' });
      } catch (e) {
        this.$toasted.global.failedRequest({ message: 'Opslaan mislukt' });
      }
      this.$store.commit('setLoading', false);
    },
  },
};
</script>
